export const getDataEntryAreasContent = (t: any): string[] => [
  t('AREAS.ENTITY_MAINTAINING_REGISTER_OF_INFORMATION'),
  t('AREAS.ENTITY'),
  // t('AREAS.ALLOCATE_LICENSED_ACTIVITY'),
  t('AREAS.BRANCH'),
  t('AREAS.FUNCTION'),
  t('AREAS.ICT_SYSTEMS'),
  t('AREAS.DATA'),
  t('AREAS.ICT_THIRD_PARTY_SERVICE_PROVIDER'),
  t('AREAS.CURRENCY_AND_COSTS'),
  t('AREAS.CONTRACTUAL_INFORMATION'),
  t('AREAS.ICT_SERVICE'),
];
